import React from "react";
import { PropTypes } from "prop-types";
import { HomePageLayout } from "application/home/components";
import { Category, CategoryPageHeader } from "application/categories/components";
import { MrbPageHeader } from "mrb/components/layout";
import { defaultTemplate } from "common/hoc";

function StoriesPageTemplate({ storiesViewStore, t }) {
    return (
        <HomePageLayout store={storiesViewStore} t={t}>
            <div>
                <MrbPageHeader classNameExtend="c-page__header--secondary">
                    <CategoryPageHeader store={storiesViewStore} t={t} />
                </MrbPageHeader>
                <Category store={storiesViewStore} t={t} />
            </div>
        </HomePageLayout>
    );
}

StoriesPageTemplate.propTypes = {
    storiesViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(StoriesPageTemplate);
